export default __webpack_public_path__ + "static/media/penny_face.8a3fc328.png";